<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('shapeLinks.create.subtitle') }}
        </span>
        <h3 class="page-title">{{ $t('shapeLinks.create.title') }}</h3>
      </d-col>
    </d-row>

    <shape-page/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { MODEL } from '../components/ShapeModel';
import ShapePage from '../components/ShapePage.vue';

export default {
  name: 'shape-links-create',
  components: {
    ShapePage,
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setPuzzle',
    ]),
  },
  created() {
    Events.$emit('sidebarVisible', false);
    this.setPuzzle(cloneDeep(MODEL));
  },
};
</script>
